import { createInstructionsAdapter } from "@rendering/vortex-core";
import { useEffect, useMemo, useState } from "react";
import { createVortexReactBridge } from "../vortexReactBridge";
export function useVortexPreview(_ref) {
  let {
    productConfig,
    productLoadingOptions,
    renderingInstructionsUrl,
    previewConfig,
    initializationOptions,
    onError,
    onAfterVortexUpdate,
    onBeforeVortexUpdate,
    preserveCamera,
    preservePreview,
    user,
    vortexDocumentAdapter
  } = _ref;
  const [preview, setPreview] = useState();
  const instructionsAdapter = useMemo(() => createInstructionsAdapter({
    tenant: user.tenant.id,
    category: user.referer
  }), [user]);
  // Use a singleton pattern to make React.StrictMode work
  // On StrictMode, the .dispose() function is called in the cleanup
  const vortexReactBridge = useMemo(() => {
    let value = undefined;
    return {
      get: () => {
        if (!value) {
          value = createVortexReactBridge();
        }
        return value;
      },
      dispose: () => {
        value === null || value === void 0 ? void 0 : value.dispose();
        value = undefined;
      }
    };
  }, []);
  useEffect(() => {
    let vortexDocumentAdapterResolved = vortexDocumentAdapter;
    if (!vortexDocumentAdapterResolved) {
      if (!renderingInstructionsUrl) {
        throw new Error("renderingInstructionsUrl should be defined when no vortexDocumentAdapter is provided");
      }
      vortexDocumentAdapterResolved = {
        generateCanvases: surfaces => instructionsAdapter.generateDocumentCanvases({
          surfaces,
          renderingInstructionsUrl
        }),
        dispose: () => instructionsAdapter.dispose()
      };
    }
    vortexReactBridge.get().syncWithVortex({
      previewConfig,
      productConfig,
      initializationOptions,
      onBeforeVortexUpdate,
      onAfterVortexUpdate,
      onError,
      preserveCamera,
      preservePreview,
      vortexDocumentAdapter: vortexDocumentAdapterResolved
    }).then(_ref2 => {
      let {
        preview
      } = _ref2;
      return setPreview(preview);
    });
  }, [previewConfig, productLoadingOptions, productConfig, renderingInstructionsUrl, initializationOptions, onBeforeVortexUpdate, onAfterVortexUpdate, onError, preserveCamera, preservePreview, vortexReactBridge, instructionsAdapter, vortexDocumentAdapter]);
  // Dispose on unmount
  useEffect(() => {
    return () => {
      vortexReactBridge.dispose();
    };
  }, [vortexReactBridge]);
  return {
    preview
  };
}